import React from 'react';
import { CoreStatusExtended as Status } from 'types';
import { getAssignStagesDropdownOptions } from '../../../utilities/getAssignStagesDropdownOptions/index';
import { Box, Menu, MenuButton, MenuList, MenuItemOption, MenuOptionGroup, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  isPathwayProvider: boolean;
  isPathwayStudent: boolean;
  processedByUni?: boolean;
  currentStage: string;
  configTabs: Array<Status>;
  onStageChange: (status: Status) => void;
}

const StageSelector = ({
  isPathwayProvider,
  processedByUni = false,
  isPathwayStudent,
  currentStage,
  configTabs,
  onStageChange,
}: IProps) => {
  const handleStageChange = (evt: React.MouseEvent<HTMLButtonElement>) => {
    onStageChange(evt.currentTarget.value as Status);
  };

  const TabsDropdownOptions = getAssignStagesDropdownOptions(
    configTabs,
    isPathwayStudent,
    isPathwayProvider,
    processedByUni,
  );

  return (
    <Box data-selector="student-current-stage">
      <Menu placement="bottom-end">
        <MenuButton
          aria-label="Move to stage"
          as={Button}
          variant={'solid'}
          rightIcon={<FontAwesomeIcon icon={faAngleDown} className="utility-icon" />}
        >
          {currentStage}
        </MenuButton>

        <MenuList>
          <MenuOptionGroup value={currentStage} type="radio">
            {TabsDropdownOptions.map(tab => {
              return (
                <MenuItemOption
                  key={tab.value}
                  value={tab.value}
                  data-selector="select-option"
                  onClick={handleStageChange}
                >
                  {tab.label}
                </MenuItemOption>
              );
            })}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default StageSelector;
